import { render, staticRenderFns } from "./product-modal.vue?vue&type=template&id=66f6354c&scoped=true&"
import script from "./product-modal.vue?vue&type=script&lang=js&"
export * from "./product-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-modal.vue?vue&type=style&index=0&id=66f6354c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f6354c",
  null
  
)

export default component.exports